import React from "react";
import { BarChart3, ExternalLink } from "lucide-react";

const HARD_CODED_POWERBI_URL ="https://app.powerbi.com/view?r=eyJrIjoiNGZmZGZiM2ItNTQzZi00ZDJmLWFmNzQtM2M3OGNjMjg4N2YyIiwidCI6Ijg1YTEyZDVhLTBlN2YtNGM3ZC1hZTYyLWUyNzhmYjY4ODhmOSJ9"
const RDDashboard = () => {
  const activeEmbedUrl = HARD_CODED_POWERBI_URL;
  const isConfigured = /^https?:\/\//i.test(String(activeEmbedUrl || "").trim());

  return (
    <section>
      <div className="mb-2 flex items-center justify-end">
        {isConfigured && (
          <a
            href={activeEmbedUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-600 transition-colors hover:border-indigo-300 hover:text-indigo-600"
          >
            Open
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        )}
      </div>

      <div className="overflow-hidden rounded-xl">
        {isConfigured ? (
          <iframe
            title="RD Dashboard Power BI"
            src={activeEmbedUrl}
            className="h-[78vh] min-h-[620px] w-full bg-white"
            allowFullScreen
          />
        ) : (
          <div className="flex min-h-[360px] items-center justify-center p-8 text-center">
            <div>
              <BarChart3 className="mx-auto h-10 w-10 text-slate-400" />
              <p className="mt-3 text-sm font-semibold text-slate-700">
                Power BI link not configured
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default RDDashboard;
